module.exports = __webpack_public_path__ + "img/60.74be4c30.jpg";